<app-table-form [resourceType]="resourceType" [preselectedId]="customerId" (rowSelected)="onItemSelected($event)">
</app-table-form>
